import styles from "styles/pages/cdp/database-management.module.scss";

import { Button, Drawer, Input, Label } from "@components";
import { useState } from "react";
import { If } from "shared/components/control-statements";
import { SuccessIcon } from "shared/components/Icons";

export default function CreateGroup({ visible, onClose, onCreateGroup }) {
  const [group, setGroup] = useState({});
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const save = async () => {
    setLoading(true);

    setTimeout(() => {
      setSuccess(true);
      onCreateGroup(group);
      setLoading(false);
    }, 2000);
  };

  return (
    <Drawer
      visible={visible}
      onClose={() => {
        onClose();
        setGroup({});
        setSuccess(false);
      }}
      title={success ? "Sucesso" : "Criar novo grupo"}
      subtitle={success ? `Agrupamento ${group.name} criado.` : "Mover"}
      showBackButton={!success}
      withoutTransition
    >
      <If cond={success}>
        <div className={styles.success}>
          <div className={styles.successIcon}>
            <SuccessIcon color="#1f1f1f" size={14} />
          </div>
        </div>
        <div className={styles.footer}>
          <Button
            design="primary"
            className="w-100"
            onClick={() => {
              onClose();
              setGroup({});
              setSuccess(false);
            }}
          >
            Fechar
          </Button>
        </div>
      </If>

      <If cond={!success}>
        <Label>Insira o nome do novo grupo:</Label>
        <Input
          onChange={(e) => setGroup({ ...group, name: e.target.value })}
          value={group.name}
          placeholder="Ex.: Grupo 1"
        />

        <div className={styles.footer}>
          <Button
            design="primary"
            onClick={save}
            loading={loading}
            className="w-100"
            disabled={!group.name || loading}
          >
            Criar e mover
          </Button>
        </div>
      </If>
    </Drawer>
  );
}
